import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useParams } from 'react-router-dom';
import { head, pathOr } from 'ramda';
import { __ } from '@wordpress/i18n';

// components
import ModalEditBrief from '../../../ModalEditBrief';

// icons
import PencilIcon from '../../../../icons/PencilIcon';

// store
import { useStoreValue } from '../../../../store';
import { useCommCenter } from '../../context';

const getInitials = (name) => String(name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase();

/**
 * Brief tab of the project sidebar: who commissioned the project, plus the
 * brief itself rendered from markdown. Editing still goes through the existing
 * ModalEditBrief, only the trigger is restyled to the sidebar's button set —
 * and only producers and directors are offered it.
 */
const BriefPanel = () => {
    const { projectId } = useParams();
    const projects = useStoreValue('projects');
    const { briefFallback, can } = useCommCenter();

    const stored = pathOr({}, [], head((projects || []).filter(o => o.id === projectId)));
    const project = stored.id ? stored : (briefFallback || {});
    const client = project.client || __('Cliente', 'soundbetween');

    return (
        <div className="commPanel commPanel--brief">
            <header className="briefPanel__header">
                <div className="activityAvatar activityAvatar--initials">
                    {project.profile_picture_url
                        ? <img src={project.profile_picture_url} alt={client}/>
                        : <span>{getInitials(client) || '—'}</span>}
                </div>
                <div className="briefPanel__meta">
                    <span className="briefPanel__client">{client}</span>
                    <span className="briefPanel__role">{__('Committente', 'soundbetween')}</span>
                </div>
                {can.editBrief && (
                    <ModalEditBrief
                        projectId={project.id}
                        brief={project.brief}
                        renderTrigger={(open) => (
                            <button type="button" className="commButton commButton--ghost" onClick={open}>
                                <PencilIcon/>
                                {__('Modifica', 'soundbetween')}
                            </button>
                        )}/>
                )}
            </header>

            <OverlayScrollbarsComponent
                element="div"
                className="briefPanel__body"
                options={{ scrollbars: { autoHide: 'never' } }}
                defer>
                {project.brief
                    ? (
                        <div className="briefPanel__markdown">
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>{project.brief}</ReactMarkdown>
                        </div>
                    )
                    : (
                        <p className="commCenter__empty">
                            {__('Nessun brief ancora inserito per questo progetto.', 'soundbetween')}
                        </p>
                    )}
            </OverlayScrollbarsComponent>
        </div>
    )
}

export default BriefPanel;
